<template>
  <div
    v-if="text"
    :class="{ 'px-2 pb-4 pt-3 text-[14px] leading-6': isChapter }"
  >
    <div class="inline" v-html="textComputed"></div>
    <span
      v-show="needHiddenText && !isShowMore"
      class="ml-1 cursor-pointer select-none text-[#004AA1]"
      @click="isShowMore = true"
    >
      Подробнее...
    </span>
    <div
      v-show="needHiddenText && isShowMore"
      class="mt-4 cursor-pointer select-none text-[#004AA1]"
      @click="isShowMore = false"
    >
      Свернуть
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  text: {
    type: String,
    default: '',
  },
  charCount: {
    type: Object,
    default: () => {
      return {
        sm: 50,
        md: 180,
        xl: 250,
        '2xl': 300,
      };
    },
  },
  isChapter: {
    type: Boolean,
    default: false,
  },
});

const { getScreenBreakpoint } = useBreakpoint();

const isShowMore = ref(false);

const needHiddenText = computed(() => {
  return props.text?.length > props.charCount?.[getScreenBreakpoint.value];
});

const textComputed = computed(() => {
  if (!props.text) return;

  const preamble = props.text;
  if (!needHiddenText.value) return preamble;
  return isShowMore.value
    ? preamble
    : props.isChapter
    ? ''
    : preamble.slice(0, props.charCount[getScreenBreakpoint.value]);
});
</script>
